import React, { PureComponent, Fragment } from 'react';
import { Form, Radio, Slider, Button, InputNumber, message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { cloneDeep } from 'lodash';
import { EntryList } from './entry-list';
import { ImageAdItem } from './image-ad-item';
import { UploadImg } from './upload-img';
import { ConfigFormDecorator } from '../../tools';
import DetailTitle from '../../DetailTitle';
import { language } from '../../../language';
import { HotZoneEditor } from '../../../../components';
import './index.less';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const MAX_ENTRY_COUNT = 12;
const wrapName = 'entry';
const result = 'hotZoneList';
const interpolate = services.interpolate;

const styleList = [
    {
        id: 1,
        name: '样式一',
        left: '0px',
    },
    {
        id: 2,
        name: '样式二',
        left: '20px',
    },
    {
        id: 3,
        name: '样式三',
        left: '20px',
    },
    {
        id: 4,
        name: '样式四',
        left: '20px',
    },
    {
        id: 5,
        name: '热区',
        left: '20px',
    },
];

const templateList = [
    {
        id: 1,
        name: '一行一个半',
        right: '20px',
    },
    {
        id: 2,
        name: '一行两个半',
        right: '20px',
    },
    {
        id: 3,
        name: '一行三个半',
        right: '20px',
    },
];

const formTopLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const formItemLayout = {
    labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 },
    },
};

const labelImgList = [
    {
        label: '背景图片',
        k: 'backgroundImage',
        tip: '建议尺寸:726x726',
    },
    {
        label: '选中标签图',
        k: 'checkImage',
        tip: '建议尺寸:363x63',
    },
    {
        label: '未选中标签图',
        k: 'uncheckImage',
        tip: '建议尺寸:363x63',
    },
];

// tab标签在h5中的宽度
const tabWidths = { 1: 193.2, 2: 121.44 };

/**
 * 图文组件-配置表单
 */
class TabCom extends PureComponent<any> {
    state = { hotZoneVisible: false, tabIndex: null };

    // 修改样式类型
    handleChangeStyle = (item: object) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();

        onChange({ ...formValue, ...item });
    };

    // 修改tab数量
    handleChangeTabNumber = (item: any) => {
        const {
            value: { tabList },
            onChange,
            form,
        } = this.props;
        const formValue = form.getFieldsValue();
        if (item.tabNumber === 2) {
            tabList.push({
                id: 3,
                tmpId: 1,
                imagePosition: 30,
                imageNumber: 2,
                imageBothSides: 16,
                imageUD: 16,
                pageMargin: 16,
                imageMargin: 16,
                imageBorder: 0,
                imgList: [],
                backgroundImage: '',
                checkImage: '',
                uncheckedImage: '',
            });

            onChange({ ...formValue, ...item, tabList });
        } else {
            const newTabList = tabList.splice(0, 2);
            onChange({ ...formValue, ...item, tabList: newTabList });
        }
    };

    // 修改tab内容
    handleChangeItem = (index: number, item: object) => {
        const {
            value: { tabList },
            onChange,
            form,
        } = this.props;
        const formValue = form.getFieldsValue();

        tabList[index] = { ...tabList[index], ...item };

        onChange({ ...formValue, tabList, activeIndex: index });
    };

    // 修改广告位组件
    handleChangeTabList = (e: any, i: any) => {
        const {
            onChange,
            form,
            value: { tabList },
        } = this.props;
        const newTabList = cloneDeep(tabList);
        newTabList[i].imgList = e[i].imgList;
        const formValue = form.getFieldsValue();

        onChange({ ...formValue, tabList: newTabList, activeIndex: i });
    };

    // 渲染标签图片区域
    renderLabelImg = (tabItem: any, tabIndex: number) => {
        const {
            form: { getFieldDecorator },
        } = this.props;

        return labelImgList.map((item) => (
            <FormItem {...formItemLayout} label={item.label} key={item.k}>
                {[
                    getFieldDecorator(item.k),
                    <UploadImg
                        {...this.props}
                        item={tabItem}
                        tip={item.tip}
                        k={item.k}
                        onChangeItem={(path) => this.handleChangeItem(tabIndex, { [item.k]: path })}
                    />,
                ]}
            </FormItem>
        ));
    };

    // 渲染滑块区域
    renderContent = (tabItem: any, tabIndex: number) => {
        const {
            form: { getFieldDecorator },
            value: { showStyle, tabList },
            linkTypes,
            linkTypeMode,
        } = this.props;

        const tmpIdItem = (
            <FormItem {...formItemLayout} label="选择模板">
                {[
                    getFieldDecorator('tmpId'),
                    templateList.map((item) => (
                        <Button
                            type={tabItem.tmpId === item.id ? 'primary' : 'default'}
                            shape="round"
                            style={{ marginRight: item.right }}
                            onClick={() => this.handleChangeItem(tabIndex, { tmpId: item.id })}
                        >
                            {item.name}
                        </Button>
                    )),
                ]}
            </FormItem>
        );

        const imagePositionItem = (
            <FormItem {...formItemLayout} label="轮播图位置">
                {[
                    getFieldDecorator('imagePosition'),
                    <InputNumber
                        style={{ width: '80px' }}
                        min={0}
                        defaultValue={tabItem.imagePosition}
                        onChange={(e) => this.handleChangeItem(tabIndex, { imagePosition: e })}
                    />,
                ]}
            </FormItem>
        );

        const imageNumberItem = (
            <FormItem {...formItemLayout} label="内容图片数量">
                {[
                    getFieldDecorator('imageNumber'),
                    <RadioGroup
                        className="fill-style"
                        defaultValue={tabItem.imageNumber}
                        onChange={({ target }) =>
                            this.handleChangeItem(tabIndex, {
                                imageNumber: target.value,
                            })
                        }
                    >
                        <Radio value={2}>一行两个</Radio>
                        <Radio value={3}>一行三个</Radio>
                        <Radio value={4}>一行四个</Radio>
                    </RadioGroup>,
                ]}
            </FormItem>
        );

        const imageBorderItemLabel = showStyle !== 5 ? '图片圆角' : '背景圆角';
        const imageBorderItem = (
            <FormItem {...formItemLayout} label={imageBorderItemLabel}>
                {[
                    getFieldDecorator('imageBorder'),
                    <Slider
                        max={100}
                        min={0}
                        defaultValue={tabItem.imageBorder}
                        onChange={(e) => this.handleChangeItem(tabIndex, { imageBorder: e })}
                    />,
                ]}
            </FormItem>
        );

        const imageBothSidesItem = (
            <FormItem {...formItemLayout} label="图片左右间隙">
                {[
                    getFieldDecorator('imageBothSides'),
                    <Slider
                        max={100}
                        min={0}
                        defaultValue={tabItem.imageBothSides}
                        onChange={(e) =>
                            this.handleChangeItem(tabIndex, {
                                imageBothSides: e,
                            })
                        }
                    />,
                ]}
            </FormItem>
        );

        const imageUDItem = (
            <FormItem {...formItemLayout} label="图片上下间隙">
                {[
                    getFieldDecorator('imageUD'),
                    <Slider
                        max={100}
                        min={0}
                        defaultValue={tabItem.imageUD}
                        onChange={(e) => this.handleChangeItem(tabIndex, { imageUD: e })}
                    />,
                ]}
            </FormItem>
        );

        const pageMarginItemLabel = showStyle !== 5 ? '轮播图页面边距' : '页面边距';
        const pageMarginItem = (
            <FormItem {...formItemLayout} label={pageMarginItemLabel}>
                {[
                    getFieldDecorator('pageMargin'),
                    <Slider
                        max={30}
                        min={0}
                        defaultValue={tabItem.pageMargin}
                        onChange={(e) => this.handleChangeItem(tabIndex, { pageMargin: e })}
                    />,
                ]}
            </FormItem>
        );

        const imageMarginItem = (
            <FormItem {...formItemLayout} label="图片边距">
                {[
                    getFieldDecorator('imageMargin'),
                    <Slider
                        max={100}
                        min={0}
                        defaultValue={tabItem.imageMargin}
                        onChange={(e) => this.handleChangeItem(tabIndex, { imageMargin: e })}
                    />,
                ]}
            </FormItem>
        );

        const hotZoneCount = this.props.value[`${result}_${tabIndex}`] || [];
        const editHotArea = (
            <FormItem {...formItemLayout} label="编辑热区">
                <Button onClick={() => this.handleEditHotZone(true, tabIndex)}>添加热区</Button>
                <span style={{ color: '#F2A861', marginLeft: '20px' }}>
                    当前创建了{hotZoneCount.length}个热区
                </span>
            </FormItem>
        );

        const entry = (
            <Fragment key={tabIndex}>
                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            tabList={tabList}
                            tabIndex={tabIndex}
                            form={this.props.form}
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapImageAdItem}
                            onChangeItem={(e, i) => this.handleChangeTabList(e, i)}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.ImageAd.tips'), {
                        max: MAX_ENTRY_COUNT,
                    })}
                </p>
            </Fragment>
        );

        const elemsnts = {
            1: [
                imagePositionItem,
                imageNumberItem,
                imageBorderItem,
                imageBothSidesItem,
                imageUDItem,
                pageMarginItem,
                entry,
            ],
            2: [
                tmpIdItem,
                imagePositionItem,
                pageMarginItem,
                imageMarginItem,
                imageBorderItem,
                entry,
            ],
            3: [imagePositionItem, imageBorderItem, entry],
            4: [imagePositionItem, imageBorderItem, entry],
            5: [editHotArea, imageBorderItem, pageMarginItem],
        };

        return elemsnts[showStyle];
    };

    // 渲染广告位组件
    WrapImageAdItem = (props) => {
        const { uploadAction, selector, sourceRoot } = this.props;
        return (
            <ImageAdItem
                {...props}
                sourceRoot={sourceRoot}
                selector={selector}
                uploadAction={uploadAction}
            />
        );
    };

    handleEditHotZone = (visible: boolean, index: number) => {
        this.setState({ tabIndex: index }, () => {
            const { tabList } = this.props.value;
            const { backgroundImage, checkImage, uncheckImage } = tabList[index];

            if (backgroundImage && checkImage && uncheckImage) {
                setTimeout(() => this.setState({ hotZoneVisible: visible }), 50);
            } else {
                message.warning('请先上传背景图和标签图');
            }
        });
    };

    render() {
        const {
            form: { getFieldDecorator },
            value: { showStyle, tabNumber, tabList },
            linkTypeMode,
            onChange,
        } = this.props;

        const { hotZoneVisible, tabIndex } = this.state;
        const tabNameGroup = ['一', '二', '三'];
        const tabItem = tabList[tabIndex] || {};
        const hotZoneList = this.props.value[`${result}_${tabIndex}`] || [];
        const bg = tabItem.backgroundImage || '';

        return (
            <Form className="editor-tabs">
                <FormItem {...formTopLayout} label="选择样式">
                    {[
                        getFieldDecorator('showStyle'),
                        styleList.map((item) => (
                            <Button
                                type={showStyle === item.id ? 'primary' : 'default'}
                                shape="round"
                                style={{ marginLeft: item.left }}
                                key={item.id}
                                onClick={() => this.handleChangeStyle({ showStyle: item.id })}
                            >
                                {showStyle === item.id}
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>

                <FormItem {...formTopLayout} label="tab数量">
                    {[
                        getFieldDecorator('tabNumber', {}),
                        <RadioGroup
                            className="fill-style"
                            defaultValue={tabNumber}
                            onChange={({ target }) =>
                                this.handleChangeTabNumber({ tabNumber: target.value })
                            }
                        >
                            <Radio value={1}>两个</Radio>
                            <Radio value={2}>三个</Radio>
                        </RadioGroup>,
                    ]}
                </FormItem>

                <div className="editor-tabs-content">
                    {tabList.map((item: any, index: number) => (
                        <div className="editor-tabs-content-item" key={index}>
                            {[
                                <div style={{ paddingLeft: '70px', boxSizing: 'border-box' }}>
                                    <DetailTitle label={`Tab组${tabNameGroup[index]}`} />
                                </div>,
                                this.renderLabelImg(item, index),
                                this.renderContent(item, index),
                            ]}
                        </div>
                    ))}
                </div>

                <HotZoneEditor
                    key={tabIndex}
                    {...this.props}
                    form={this.props.form}
                    source={{
                        from: 'tab',
                        data: { imgUrl: tabItem.checkImage, tabWidth: tabWidths[tabNumber] },
                    }}
                    index={tabIndex}
                    result={`${result}_${tabIndex}`}
                    wrapName={`${wrapName}_${tabIndex}`}
                    visible={hotZoneVisible}
                    maxCount={20}
                    linkTypeMode={linkTypeMode}
                    imgUrl={bg}
                    hotZoneList={hotZoneList}
                    onChange={onChange}
                    onClose={(index) => this.handleEditHotZone(false, index)}
                />
            </Form>
        );
    }
}

export const CommodityTab = ConfigFormDecorator(TabCom);
